import { useState } from 'react';
import axiosInstance from '../../interceptor/axiosInstance';
import { ApiRoutes } from '../../routes/routeConstants/apiRoutes';
import { MetaData } from 'models/MetaData/metaData.model';
import { generatePath } from 'react-router-dom';
import { CompanyDashboardProps } from 'views/CompanyDashboard/constants';

const MetadataService = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [sizeMetaData, setsizeMetaData] = useState<MetaData[]>([]);
  const [yearsMetaData, setYearsMetaData] = useState<MetaData[]>([]);
  const [yearsMetaDataByOrg, setYearsMetaDataByOrg] = useState<MetaData[]>([]);
  const [locMetaDataByOrg, setLocMetaDataByOrg] = useState<MetaData[]>([]);
  const [belongsMetaData, setBelongsMetaData] = useState<MetaData[]>([]);
  const [companyTypesMeta, setCompanyTypesMeta] = useState<MetaData[]>([]);

  const fetchSizeMetaData = async () => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(ApiRoutes.META_SIZE_ORG, {
        params: {
          metadata_type: 'organization_size',
        },
      });

      setsizeMetaData(response.data.data.metadata);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchYearsMetaData = async () => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(ApiRoutes.META_SIZE_ORG, {
        params: {
          metadata_type: 'location_years',
        },
      });

      setYearsMetaData(response.data.data.metadata);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchYearsMetaDataByOrg = async (id: number) => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(ApiRoutes.META_SIZE_ORG, {
        params: {
          metadata_type: CompanyDashboardProps.ORG_YEARS,
          organization_id: id,
        },
      });

      setYearsMetaDataByOrg(response.data.data.metadata);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchLocMetaDataByOrg = async (id: number, year: number) => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(
        generatePath(ApiRoutes.GET_LOCATIONS_ORG, { organisationId: id }),
        {
          params: {
            year,
          },
        }
      );
      const updatedLocationData = [
        { id: CompanyDashboardProps.ALL, name: CompanyDashboardProps.ALL },
        ...response.data.locations,
      ];
      setLocMetaDataByOrg(updatedLocationData);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchBelongsMetaData = async () => {
    try {
      setLoading(true);

      const response = await axiosInstance.get(ApiRoutes.META_SIZE_ORG, {
        params: {
          metadata_type: 'organizations',
        },
      });

      setBelongsMetaData(response.data.data.metadata);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchCompanyTypesMeta = async () => {
    try {
      setLoading(true);

      const url = generatePath(ApiRoutes.META_COMPANY_TYPES);
      const response = await axiosInstance.get(url);

      setCompanyTypesMeta(response.data.data.metadata);
    } catch (error) {
      setCompanyTypesMeta([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    sizeMetaData,
    yearsMetaData,
    yearsMetaDataByOrg,
    locMetaDataByOrg,
    belongsMetaData,
    companyTypesMeta,
    fetchSizeMetaData,
    fetchYearsMetaData,
    fetchYearsMetaDataByOrg,
    fetchLocMetaDataByOrg,
    fetchBelongsMetaData,
    fetchCompanyTypesMeta,
  };
};

export default MetadataService; 